import React from "react";
import { Modal, Button } from "reactstrap";
import { handlePostRequest } from "../../helpers/handle-response";

const DeleteModal = ({ open, setOpen, rowToDelete, deleteStroj }) => {
  return (
    <Modal
      className="modal-dialog-centered"
      size={"lg"}
      isOpen={open.Delete}
      toggle={() => setOpen({ ...open, Delete: !open.Delete })}
    >
      <div className="modal-header">
        <h3 className="modal-title" id="exampleModalLabel">
          Obriši stroj
        </h3>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={() => setOpen({ ...open, Delete: !open.Delete })}
        >
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <div className="mx-auto">
        <h2 className="ml-4 ml-sm-0">Jeste li sigurni da želite obrisati stroj?</h2>
        <ul>
          <li>
            Marka stroja:{" "}
            <span className="font-weight-bold"> {rowToDelete.MarkaStroja}</span>
          </li>
          <li>
            Tip stroja:{" "}
            <span className="font-weight-bold"> {rowToDelete.TipStroja}</span>
          </li>
          <li>
            Registracijska oznaka:{" "}
            <span className="font-weight-bold">
              {" "}
              {rowToDelete.RegistracijskaOznaka}
            </span>
          </li>
        </ul>
        <Button
          className="mx-auto my-2 d-flex"
          color="danger"
          onClick={deleteStroj}
        >
          Obriši
        </Button>
      </div>
    </Modal>
  );
};

export default DeleteModal;
